import React from "react";
import { Typography } from "antd";

const badgeStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 24,
  height: 24,
  borderRadius: 6,
  background: "#1677ff",
  color: "#fff",
  fontSize: 13,
  fontWeight: 600,
  flexShrink: 0,
};

export const LeanCustomsNumberedSection: React.FC<{
  number: number;
  title: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  /** Orange highlight when this section still needs attention */
  attention?: boolean;
}> = ({ number, title, children, style, attention = false }) => (
  <section
    style={{
      border: attention ? "1px solid #ffa940" : "1px solid #f0f0f0",
      borderRadius: 8,
      padding: "14px 16px 16px",
      marginBottom: 16,
      background: attention ? "#fff7e6" : "#fafafa",
      ...style,
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 14,
      }}
    >
      <span
        style={{
          ...badgeStyle,
          background: attention ? "#fa8c16" : badgeStyle.background,
        }}
      >
        {number}
      </span>
      <Typography.Text strong style={{ fontSize: 14, color: attention ? "#d46b08" : undefined }}>
        {title}
      </Typography.Text>
    </div>
    <div
      style={{
        background: "#fff",
        borderRadius: 6,
        padding: "12px 14px",
        border: attention ? "1px solid #ffd591" : "1px solid #f0f0f0",
      }}
    >
      {children}
    </div>
  </section>
);
